import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const analyticsKeys = {
	geoFlows: (days: number) => ["analytics", "geo-flows", days] as const,
	metrika: (days: number) => ["analytics", "metrika", days] as const,
};

/** Блок «Метрика» на дашборде (fd-analytics-05). Шлюз кеширует отчёт на час. */
export function useMetrikaReport(days: number) {
	return useQuery({
		queryKey: analyticsKeys.metrika(days),
		queryFn: () => api.analytics.metrika(days),
		refetchOnWindowFocus: false,
		staleTime: 5 * 60_000,
	});
}

export function useGeoFlows(days: number, limit = 20) {
	return useQuery({
		queryKey: analyticsKeys.geoFlows(days),
		queryFn: () => api.analytics.geoFlows({ days, limit }),
		refetchOnWindowFocus: false,
	});
}
